
import React from 'react';
import { BaseCrud, FormSection, FormSectionColumn } from 'react/containers/layout/Crud';
import { TextField, LookupField, CheckboxField } from 'react/components/fields';

const CheckpointItemReasonCrud = (props) => (
  <BaseCrud updateMethod="PATCH" tabName="CheckpointItemReason.title" {...props}>
    <FormSection title="CheckpointItemReason.section.general.title">
      <FormSectionColumn>
        <TextField
          label="CheckpointItemReason.field.key"
          name="key"
          disabledOnEdit
          required
        />
        <LookupField
          label="CheckpointItemReason.field.organization"
          name="organization"
          lookupEntity="Organization"
          lookupEntityColumn="description"
          disabledOnEdit
          required
        />
        <TextField
          label="CheckpointItemReason.field.description"
          name="description"
          required
        />
        <CheckboxField
          label="CheckpointItemReason.field.enabled"
          name="enabled"
        />
        <CheckboxField
          label="CheckpointItemReason.field.enabledDriverCheckin"
          name="enabledDriverCheckin"
        />
        <CheckboxField
          label="CheckpointItemReason.field.enabledDepotCheckin"
          name="enabledDepotCheckin"
        />
      </FormSectionColumn>
    </FormSection>
  </BaseCrud>
);

export default CheckpointItemReasonCrud;
